import { render, staticRenderFns } from "./listCard.vue?vue&type=template&id=65f3a512&scoped=true"
import script from "./listCard.vue?vue&type=script&lang=js"
export * from "./listCard.vue?vue&type=script&lang=js"
import style0 from "./listCard.vue?vue&type=style&index=0&id=65f3a512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3a512",
  null
  
)

export default component.exports